import { render, staticRenderFns } from "./Tutti.vue?vue&type=template&id=a532bd0c"
import script from "./Tutti.vue?vue&type=script&lang=js"
export * from "./Tutti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports